import gql from 'graphql-tag';

export const GET_LENDER_PERFORMANCE_TREND = gql`
  query LenderPerformanceTrend($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      result: trend(input: $input) {
        success
        error
        entity {
          month
          approvalRate
          fundRate
          lookToBook
        }
      }
    }
  }
`;
